import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ManufacturerAnnouncementCategory, UpdateManufacturerAnnouncementCategoryPayload } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseMutationOptions<unknown, Error, UpdateManufacturerAnnouncementCategoryPayload, ManufacturerAnnouncementCategory>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useEditManufacturerAnnouncementCategoryRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, UpdateManufacturerAnnouncementCategoryPayload, ManufacturerAnnouncementCategory>(
    [Entities.ManufacturerAnnouncementCategory, 'edit', id],
    async (payload: UpdateManufacturerAnnouncementCategoryPayload) => {
      const { data } = await api.v1AdminManufacturersAnnouncementsCategoriesCategoryIdPut(
        id,
        payload,
      )
      return data
    },
    options,
  )
}
